<template>
    <div id="allergy-kpi-report">
      <Navigation></Navigation>
      <Filters></Filters>
      <ContentBody v-if="report"></ContentBody>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { MoonLoader } from 'vue-spinner/dist/vue-spinner.min.js';
  import Navigation from '../allergy-kpis/Navigation.vue';
  import Filters from '../allergy-kpis/Filters.vue';
  import ContentBody from '../allergy-kpis/ContentBody.vue';

  export default {
    name: 'AllergyKpisLayout',
    components: {
      MoonLoader,
      Navigation,
      Filters,
      ContentBody,
    },
    async created() {
      // this.$store.dispatch('allergyKpis/setProperty', { key: 'activeSection', value: this.$route.path.replace(/^\//, '').split('/')[1] });
      if (!this.initializers.years) {
        this.$store.dispatch('allergyKpis/getAllergyKpisYearStart');
        await this.$store.dispatch('allergyKpis/getAllergyKpisYears');
      }
    },
    computed: {
      ...mapGetters('allergyKpis', ['initializers', 'loaders', 'report']),
    },
  };
</script>
